import styled from 'styled-components';
import { Button } from "antd";

export const CartContainer = styled.div`
  max-width: 840px;
  margin: 0 auto;
  padding: clamp(1.5rem, 5vw, 3rem) var(--gutter) clamp(3rem, 8vw, 5rem);
  min-height: 60vh;

  h2 {
    text-align: left;
    font-family: var(--font-serif);
    font-weight: 400;
    font-size: var(--step-3);
    color: var(--ink);
    margin-bottom: clamp(1.25rem, 4vw, 2rem);
  }
`;

export const CartItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: clamp(0.85rem, 3vw, 1.25rem);
  padding: clamp(0.9rem, 3vw, 1.25rem) 0;
  border-bottom: 1px solid var(--line);
`;

export const ProductImage = styled.img`
  width: clamp(78px, 24vw, 96px);
  height: clamp(100px, 30vw, 124px);
  object-fit: cover;
  background: var(--surface-2);
  border-radius: var(--radius-sm);
  background: var(--surface-2);
  flex-shrink: 0;
`;

export const ProductInfo = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0.85rem;

  @media (min-width: 600px) {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  p {
    margin: 0;
    color: var(--ink);
    font-size: var(--step-0);
    line-height: 1.45;
  }

  > div {
    display: flex;
    align-items: center;
    gap: 0.4rem;
  }

  button {
    width: 40px;
    height: 40px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: var(--surface);
    border: 1px solid var(--line);
    border-radius: var(--radius-pill);
    color: var(--ink);
    font-size: 0.8rem;
    cursor: pointer;
    transition: background var(--dur) var(--ease), color var(--dur) var(--ease),
      border-color var(--dur) var(--ease);

    &:hover {
      background: var(--ink);
      border-color: var(--ink);
      color: var(--ink-inverse);
    }
  }
`;

export const CheckoutButton = styled(Button)`
  && {
    margin-top: 1.25rem;
    width: 100%;
    min-height: 54px;
    background-color: var(--ink);
    color: var(--ink-inverse);
    border: none;
    border-radius: var(--radius-pill);
    font-size: var(--step--1);
    font-weight: 500;
    letter-spacing: 0.14em;
    text-transform: uppercase;

    &:hover,
    &:focus {
      background-color: var(--ink) !important;
      color: var(--ink-inverse) !important;
      opacity: 0.9;
    }
  }
`;

export const TotalSection = styled.div`
  text-align: right;

  p {
    margin: 0.35rem 0;
    font-size: var(--step-0);
    color: var(--ink-soft);
  }
  p:last-of-type {
    color: var(--ink);
    font-weight: 500;
    font-size: var(--step-1);
  }
`;

export const CartSummary = styled.div`
  margin-top: clamp(1.5rem, 4vw, 2.25rem);
  padding-top: 1.5rem;
  border-top: 1px solid var(--line);
`;

export const EmptyCart = styled.div`
  text-align: center;
  padding: clamp(2.5rem, 10vw, 5rem) 0;

  p {
    font-size: var(--step-1);
    color: var(--muted);
    margin-bottom: 1.5rem;
  }

  a {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: 52px;
    padding: 0 2rem;
    background: var(--ink);
    color: var(--ink-inverse);
    border-radius: var(--radius-pill);
    font-size: var(--step--1);
    letter-spacing: 0.14em;
    text-transform: uppercase;
    transition: opacity var(--dur) var(--ease);
  }
  a:hover {
    opacity: 0.9;
  }
`;

export const PromoRow = styled.form`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 1.25rem;
`;

export const PromoInput = styled.input`
  flex: 1;
  min-width: 160px;
  min-height: 48px;
  padding: 0 1.1rem;
  border: 1px solid var(--line-strong);
  border-radius: var(--radius-pill);
  background: var(--bg);
  color: var(--ink);
  font-size: var(--step-0);
  text-transform: uppercase;
  letter-spacing: 0.06em;

  &::placeholder {
    text-transform: none;
    letter-spacing: 0;
    color: var(--muted);
  }
  &:focus {
    outline: none;
    border-color: var(--ink);
  }
`;

export const PromoButton = styled.button`
  min-height: 48px;
  padding: 0 1.5rem;
  border: 1px solid var(--ink);
  border-radius: var(--radius-pill);
  background: var(--ink);
  color: var(--ink-inverse);
  font-size: var(--step--1);
  font-weight: 500;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  cursor: pointer;
  transition: opacity var(--dur) var(--ease);

  &:hover {
    opacity: 0.9;
  }
`;

export const PromoTag = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 1.25rem;
  padding: 0.7rem 1rem;
  border: 1px dashed var(--accent);
  border-radius: var(--radius-md);
  background: rgba(31, 81, 48, 0.06);
  font-size: var(--step--1);
  color: var(--ink);

  button {
    background: none;
    border: none;
    color: var(--muted);
    text-decoration: underline;
    text-underline-offset: 3px;
    cursor: pointer;
    font-size: var(--step--1);
  }
  button:hover {
    color: var(--ink);
  }
`;

export const PromoError = styled.p`
  flex-basis: 100%;
  margin: 0;
  color: var(--danger);
  font-size: var(--step--1);
`;

export const EditDetailsButton = styled(Button)`
  && {
    margin-right: 10px;
    margin-bottom: 10px;
    background: transparent;
    border: 1px solid var(--ink);
    color: var(--ink);
    border-radius: var(--radius-pill);

    &:hover,
    &:focus {
      background: var(--ink) !important;
      color: var(--ink-inverse) !important;
      border-color: var(--ink) !important;
    }
  }
`;
